var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetHelpinline = function SvgGetHelpinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0073E6",
    fillRule: "evenodd",
    d: "M20 19.076c0-.136.056-.265.152-.361C21.922 16.94 23 14.585 23 12c0-5.523-4.925-10-11-10S1 6.477 1 12s4.925 10 11 10h7.5a.5.5 0 0 0 .5-.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.475 14.26v-.233q0-.969.16-1.545.165-.576.478-.924.315-.353.764-.644a6 6 0 0 0 .639-.462q.285-.24.45-.513.166-.274.166-.621 0-.336-.16-.593a1.05 1.05 0 0 0-.439-.393 1.3 1.3 0 0 0-.61-.143q-.336 0-.633.154a1.3 1.3 0 0 0-.479.439 1.25 1.25 0 0 0-.188.678H8q.017-1.197.553-1.96.541-.764 1.431-1.13A5.1 5.1 0 0 1 11.946 6q1.175 0 2.087.365.918.365 1.442 1.077.525.713.525 1.745 0 .678-.228 1.197a2.9 2.9 0 0 1-.639.918 5 5 0 0 1-.952.718 3.8 3.8 0 0 0-.713.524 1.8 1.8 0 0 0-.422.627q-.142.348-.142.856v.233zm1.26 3.74q-.615 0-1.055-.433a1.4 1.4 0 0 1-.428-1.05 1.38 1.38 0 0 1 .428-1.031 1.45 1.45 0 0 1 1.055-.433q.587 0 1.032.433A1.4 1.4 0 0 1 13 17.265a1.56 1.56 0 0 1-.542.535q-.33.2-.724.2"
  })));
};
export default SvgGetHelpinline;